var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{ref:"list",attrs:{"tableCheckbox":false,"search-time":false,"tableTitle":_vm.tableTitle,"operationList":_vm.operationList,"operationLeft":false,"searchBtn":false,"searchUrl":_vm.url,"form":_vm.form,"back":_vm.back,"refresh":true},on:{"operation-click":_vm.operation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }